import type { ApiLogsListParams, ApiLogsSortKey } from '../../types/pages'

export const DEFAULT_API_LOGS_PARAMS: ApiLogsListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'api_log_id',
  q: '',
  property_id: '',
  fromDt: '',
  toDt: '',
}

export const API_LOGS_SORT_COLUMNS: { key: ApiLogsSortKey; label: string }[] = [
  { key: 'api_log_id', label: 'Log Id' },
  { key: 'fk_applicant_id', label: 'Application ID' },
  { key: 'request_body', label: 'Request Body' },
  { key: 'response_body', label: 'Response Body' },
  { key: 'api_type', label: 'Api Type' },
  { key: 'api_method', label: 'Api Method' },
  { key: 'created_at', label: 'Created Time' },
]
